import { render, staticRenderFns } from "./CustomerDetailSessionAuthorizations.vue?vue&type=template&id=e2c0fa2e"
import script from "./CustomerDetailSessionAuthorizations.vue?vue&type=script&lang=js"
export * from "./CustomerDetailSessionAuthorizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports